var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    { staticClass: "py-0", attrs: { id: "menu-options", dense: "" } },
    [
      _vm._l(_vm.getMenuOptions, function (item) {
        return [
          item.items.length == 0
            ? [
                _c(
                  "v-list-item",
                  {
                    key: item.title,
                    staticClass: "my-1",
                    attrs: { link: "", to: item.path },
                  },
                  [
                    _c(
                      "v-list-item-icon",
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.icon) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item-content",
                      [_c("v-list-item-title", [_vm._v(_vm._s(item.title))])],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "v-list-group",
                  {
                    key: item.title,
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "appendIcon",
                          fn: function () {
                            return [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v(" fas fa-chevron-down "),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "activator",
                          fn: function () {
                            return [
                              _c(
                                "v-list-item-icon",
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.icon) +
                                        "\n            "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(item.title)),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _vm._v(" "),
                    _vm._v(" "),
                    _vm._l(item.items, function (child, i) {
                      return _c(
                        "v-list-item",
                        {
                          key: child.path,
                          staticClass: "pr-0",
                          attrs: { link: "", to: child.path },
                        },
                        [
                          !child.items || !child.items.length
                            ? _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(child.title) +
                                        "\n            "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass: "py-0",
                                      attrs: {
                                        id: "menu-sub-options",
                                        dense: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-group",
                                        {
                                          key: `${child.title}-${i}`,
                                          staticClass: "ml-0",
                                          attrs: {
                                            "prepend-icon": "",
                                            "no-action": "",
                                            "sub-group": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "appendIcon",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: { small: "" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " fas fa-chevron-down "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "activator",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "v-list-item-content",
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                child.title
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _vm._v(" "),
                                          _vm._v(" "),
                                          _vm._l(
                                            child.items,
                                            function (subchild) {
                                              return _c(
                                                "v-list-item",
                                                {
                                                  key: subchild.path,
                                                  attrs: {
                                                    id: "items-sub-options",
                                                    to: subchild.path,
                                                    link: "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              subchild.title
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ],
        ]
      }),
      _vm._v(" "),
      _c(
        "v-list-item",
        [
          _c(
            "v-btn",
            {
              staticClass: "mb-2",
              attrs: {
                href: "https://beta.wegrou.app/",
                color: "primary",
                target: "_blank",
                small: "",
                block: "",
                outlined: "",
              },
            },
            [_vm._v("\n      Probar beta\n    ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }